import { NavigateFunction } from "react-router";
import {
  ProductUrls,
  ErrorTypes,
  QuoteDetailsResponse,
  QuoteDetailsRequest,
  InvalidQuoteReason,
} from "_core/types";

import { fetchClient } from "_core/utils/fetchClient";

export const fetchQuoteDetails = async (
  requestBody: QuoteDetailsRequest,
  setLoading: (isLoading: boolean) => void,
  API_URL: string,
  setQuoteDetails: (quoteDetails: QuoteDetailsResponse) => void,
  navigate: NavigateFunction
) => {
  try {
    const quoteDetails = await fetchClient<QuoteDetailsResponse>({
      base: API_URL,
      path: "/v1/payment/quote-details",
      options: {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      },
    });

    setQuoteDetails(quoteDetails);

    setLoading(false);
  } catch (e) {
    if (!(e instanceof Response)) {
      return navigate(ProductUrls.ErrorPage, {
        state: { error: ErrorTypes.OOPS },
      });
    }

    if (
      process.env.BUILD_ENV !== "prod" &&
      e.status === 404 &&
      ((await e.text()) as InvalidQuoteReason) === "expired"
    ) {
      return navigate(ProductUrls.Expired);
    }

    switch (e.status) {
      case 400:
      case 500:
        navigate(ProductUrls.ErrorPage, {
          state: { error: ErrorTypes.SORRY_THERE_WAS_A_PROBLEM },
        });
        break;

      case 404:
        navigate(ProductUrls.ErrorPage, {
          state: { error: ErrorTypes.WE_CANT_FIND_ORDER },
        });
        break;

      default:
        navigate(ProductUrls.ErrorPage, {
          state: { error: ErrorTypes.OOPS },
        });
        break;
    }
  } finally {
    setLoading(false);
  }
};
